function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var convertPurchaseListToBackendFormat = function convertPurchaseListToBackendFormat(items) {
  var feebusterExcludedDepts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var cash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var points_config = arguments.length > 3 ? arguments[3] : undefined;
  var itmp = [];
  var t = {};
  items = Object.values(items);
  if (cash) {
    items = items.flatMap(function (item) {
      var _item$priceTaxFeeAdju;
      var feebusterPTF = (_item$priceTaxFeeAdju = item.priceTaxFeeAdjustments) === null || _item$priceTaxFeeAdju === void 0 ? void 0 : _item$priceTaxFeeAdju.find(function (ptf) {
        return ptf.name === "feebuster";
      });
      return feebusterPTF && feebusterPTF.extra.config.enabled ? feebusterPTF.extra.cashPrice : item;
    });
  }
  var uniqueUpcs = items.map(function (a) {
    return a.upc;
  }).filter(function (e) {
    return !(t[e] = e in t);
  });
  var uniquePromoUpcCache = {};
  var isEmpty = function isEmpty(obj) {
    return Object.keys(obj).length === 0;
  };
  var promosItem = function promosItem(p, type) {
    if (!["promo", "coupons", "br"].includes(type)) {
      type = "total";
    }
    var promoTotal = 0;
    if (p.priceTaxFeeAdjustments) {
      for (var i2 = 0, ptf; ptf = p.priceTaxFeeAdjustments[i2]; ++i2) {
        if (ptf.name === "promo") {
          var promoPtf = ptf;
          var condition = true;
          if (type === "promo") {
            condition = !promoPtf.extra.promo.extpromoid && promoPtf.priority < 0;
          }
          if (type === "coupons") {
            condition = !promoPtf.extra.promo.extpromoid && promoPtf.priority > 0;
          }
          if (type === "br") {
            condition = promoPtf.extra.promo.extpromoid;
          }
          promoTotal += condition ? promoPtf.price * (p.refund ? -1 : 1) : 0;
        }
      }
    }
    return promoTotal;
  };
  var isPointsExcludedDept = function isPointsExcludedDept(dept) {
    return points_config.excludedDepts.indexOf(dept) !== -1;
  };
  var manualdiscountAndPriceoverrideItem = function manualdiscountAndPriceoverrideItem(p, cash) {
    if (cash && p.priceTaxFeeAdjustments) {
      var feeBusterPtf = p.priceTaxFeeAdjustments.find(function (a) {
        return a.name === "feebuster";
      });
      if (feeBusterPtf) {
        p = feeBusterPtf.extra.cashPrice;
      }
    }
    var discountTotal = 0;
    if (p.priceTaxFeeAdjustments) {
      for (var i2 = 0, manualdiscountPtf; manualdiscountPtf = p.priceTaxFeeAdjustments[i2]; ++i2) {
        if (["manualdiscount", "priceoverride"].includes(manualdiscountPtf.name)) {
          discountTotal += manualdiscountPtf.price * (p.refund ? -1 : 1);
        }
      }
    }
    return discountTotal;
  };
  var round = function round(x) {
    return Math.round((Math.sign(x) * x).toFixed(4)) * Math.sign(x);
  };
  var objectValues = function objectValues(objV) {
    var obj = objV;
    var vals = [];
    for (var key in objV) {
      vals.push(obj[key]);
    }
    return vals;
  };

  // own code >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  /*
  var remaindersPerAuthority = { explicit: {}, implicit: {} };
  var wouldbeRemaindersPerAuthority = { explicit: {}, implicit: {} };
  var highestItemAuth = {
     explicit: {
      Tax: {
        uuid: null,
        name: null,
        amount: 0,
      },
      Fee: {
        uuid: null,
        name: null,
        amount: 0,
      },
      wouldBe: {
        Tax: {
          uuid: null,
          name: null,
          amount: 0,
        },
        Fee: {
          uuid: null,
          name: null,
          amount: 0,
        },
      },
    },
    implicit: {
      Tax: {
        uuid: null,
        name: null,
        amount: 0,
      },
      Fee: {
        uuid: null,
        name: null,
        amount: 0,
      },
      wouldBe: {
        Tax: {
          uuid: null,
          name: null,
          amount: 0,
        },
        Fee: {
          uuid: null,
          name: null,
          amount: 0,
        },
      },
    },
  };
  */
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< own code
  //* var coffeeclubService = $injector.get('coffeeclubService');
  var _loop = function _loop() {
      if (i.priceTaxFeeAdjustments) {
        i.priceTaxFeeAdjustments.sort(function (a, b) {
          return a.tax - b.tax;
        });
        promoPtfWithPartialInclusivityImpact = i.priceTaxFeeAdjustments.find(function (a) {
          return a.name === "promo" && a.extra.qtyAffected && a.extra.qtyAffected != i.effectiveQuantity;
        });
        if (promoPtfWithPartialInclusivityImpact) {
          laterPromoExists = false;
          for (j = itemIndex + 1; j < items.length; ++j) {
            laterItem = items[j];
            if (laterItem.priceTaxFeeAdjustments && laterItem.priceTaxFeeAdjustments.find(function (a) {
              return a.name === "promo" && a.extra.promo.id === promoPtfWithPartialInclusivityImpact.extra.promo.id;
            })) {
              laterPromoExists = true;
              break;
            }
          }

          // if a later item affected by this promo exists then this one is definitely not a partially affected tax/fee inc/exc item even if it has a qtyAffected that is less than its effectiveQuantity
          // so only start the splitting process if no later item appears that uses this promo
          if (!laterPromoExists) {
            authPtfs = i.priceTaxFeeAdjustments.filter(function (a) {
              return a.name === "tax" || a.name === "fee";
            });
            processedAuthPtfs = [];
            twinAuthPtfs = {}; // the following algorithm depends on the algorithm I implemented elsewhere whereby if a promo causes an item to switch inclusivity status it creates another ptf with the same name on the purchase item
            // so if we find two identically named tax/fee ptfs ("twinAuthPtfs"), we know we must split up this purchase item along the threshold of affectation of these two ptfs
            // the follwing code hunts out and collects twin ptfs
            authPtfs.forEach(function (v) {
              var twinAuthPtf = processedAuthPtfs.find(function (a) {
                return a.extra[a.name + "Rule"].name === v.extra[v.name + "Rule"].name && a.extra.totalTaxableFees === v.extra.totalTaxableFees;
              });
              if (twinAuthPtf) {
                var a = twinAuthPtf;
                twinAuthPtfs[a.extra[a.name + "Rule"].name] =
                // if more are affected than not affected
                i.qtyAffected > i.effectiveQuantity / 2 ?
                // then the one with more tax / fee comes first since that must have been the one that was affected by the promo
                a[a.name] > v[a.name] ? [a, v] : [v, a] :
                // otherwise the one with less tax / fee comes first
                a[a.name] > v[a.name] ? [v, a] : [a, v];
              }
              processedAuthPtfs.push(v);
            });

            // if we have found some, we split up the item
            var isTwinAuthPtfEmpty = isEmpty(twinAuthPtfs);
            if (!isTwinAuthPtfEmpty) {
              // we have to splice out the later PTF and give it to a new purchase-line
              secondTwinAuthPtfs = objectValues(twinAuthPtfs).map(function (a) {
                return a[1];
              });
              secondTwinAuthPtfsAuthoritynames = secondTwinAuthPtfs.map(function (a) {
                return a.extra[a.name + "Rule"].name;
              }); // calculate the second item's price and quantity based on the ratio of its part in the ptf authority sum
              firstItemNewIntPrice = round(promoPtfWithPartialInclusivityImpact.extra.qtyAffected / i.effectiveQuantity * i.intPrice);
              newItemEffectiveQty = i.effectiveQuantity - promoPtfWithPartialInclusivityImpact.extra.qtyAffected; // we create a bare item that will take the equivalent quantity that corresponds to the later ptf, takes the ptf and also takes the right revauth
              // we don't need qty to be a getter like in the original object as we're only going to use it once more ever - to send as is to the backend, below
              newItem = {
                priceTaxFeeAdjustments: secondTwinAuthPtfs,
                refund: i.refund,
                upc: i.upc,
                dept: i.dept,
                showtext: i.showtext,
                effectiveQuantity: newItemEffectiveQty,
                qty: newItemEffectiveQty * (i.byweight ? 100 : 1),
                byweight: i.byweight,
                skuqty: i.skuqty,
                skuprice: i.skuprice,
                taxinc: i.taxinc,
                brportaldata: i.brportaldata,
                revauths: i.revauths.filter(function (a) {
                  return secondTwinAuthPtfsAuthoritynames.includes(a.name);
                }),
                intPrice: i.intPrice - firstItemNewIntPrice,
                after: i.uuid
              };
              i.intPrice = firstItemNewIntPrice;
              i.qty = promoPtfWithPartialInclusivityImpact.extra.qtyAffected * (i.byweight ? 100 : 1);
              // we seem to have lost our setter at this point but I don't know why
              i.effectiveQuantity = promoPtfWithPartialInclusivityImpact.extra.qtyAffected;
              i.priceTaxFeeAdjustments = i.priceTaxFeeAdjustments.filter(function (a) {
                return !secondTwinAuthPtfs.includes(a);
              });
              // thanks to using a "for" loop instead of "foreach" this will get processed as another regular item after all the other items in the purchase-list
              items.push(newItem);
            }
          }
        }
      }
      i3 = {
        refund: i.refund,
        uuid: i.uuid,
        after: i.after
      };
      refundCoef = i.refund ? -1 : 1;
      if (i.upc) {
        // ...scan purchase
        i3.upc = i.upc;
        // own code >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
        i3.name = i.showtext;
        i3.dept = i.dept;
        // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< own code
      } else {
        // ...department purchase
        i3.upc = null;
        i3.dept = i.dept;

        // ...if "showtext" exists
        if (i.showtext) {
          // ...strip off any '[A-Z]-' preamble
          i3.name = i.showtext.replace(/^[A-Z]-/, "");
          i3.name = i3.name.replace(/&nbsp;/g, " ");
        }
      }
      i3.qty = i.qty;

      /*
      // here using for calculate specific BR club promo. it is not a part of regular promo.
       let extpromoinfo = purchaseService.getBrCouldSaveList(itemIndex);
      let extpromoid =
        extpromoinfo && extpromoinfo.extpromoid
          ? extpromoinfo.extpromoid.split(",")[0]
          : null;
       // till we don't have brClub promo support it will be always 0
       let couldsave =
        extpromoinfo && extpromoinfo.cents
          ? -purchaseService.round(extpromoinfo.cents)
          : 0;
      */

      // own code >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
      // let promo = i.priceTaxFeeAdjustments
      //   ? i.priceTaxFeeAdjustments
      //       .filter((a) => a.name === "promo")
      //       .map((a) => a.price)
      //       .reduce((a, b) => a + b, 0) * refundCoef
      //   : 0;

      // let promo = 0;
      // let discount = i.priceTaxFeeAdjustments
      //   ? i.priceTaxFeeAdjustments
      //       .filter((a) => a.name === "manualdiscount")
      //       .map((a) => a.price)
      //       .reduce((a, b) => a + b, 0) * refundCoef
      //   : 0;
      // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< own code

      //  pclubadj: -purchaseService.totals.promosItem(i, 'br'),
      //  promoadj: -purchaseService.totals.promosItem(i, 'promo'),

      var promosTotal = promosItem(i, "promo"); // these are specifically pre-tax promos
      var totalDiscount = -manualdiscountAndPriceoverrideItem(i, cash);
      i3.soldAt = {
        discadj: totalDiscount,
        promoid: null,
        promoadj: -promosTotal,
        extpromoid: null,
        pclubadj: 0,
        couldsave: 0
      };
      i3.voided = false;
      i3.revauths = [];
      var basePrice = i.intPrice;
      var tax_exempt = i.priceTaxFeeAdjustments ? !!i.priceTaxFeeAdjustments.find(function (a) {
        return ["ebt", "wic", "ewic", "taxfreesale"].includes(a.name);
      }) : false;
      // the following line is a stub for future accommodation of fee-exempting components
      var fee_exempt = false;
      var ebtPriceAmount = i.priceTaxFeeAdjustments ? i.priceTaxFeeAdjustments.filter(function (a) {
        return a.name === "ebt";
      }).reduce(function (total, a) {
        return total + a.extra.redemption.price;
      }, 0) * refundCoef : 0;
      var ebtFeeAmount = i.priceTaxFeeAdjustments ? i.priceTaxFeeAdjustments.filter(function (a) {
        return a.name === "ebt";
      }).reduce(function (total, a) {
        return total + a.extra.redemption.fee;
      }, 0) * refundCoef : 0;
      var pretaxAdjusters = (i.priceTaxFeeAdjustments ? +i.priceTaxFeeAdjustments
      // exclude post-tax but not implicit tax
      .filter(function (a) {
        return a.priority <= 0;
      })
      // sum up price PTFs and EBT redemption
      .reduce(function (total, a) {
        return total + a.price;
      }, 0) : 0) * refundCoef;
      otherPtfs = (i.priceTaxFeeAdjustments ? +i.priceTaxFeeAdjustments
      // exclude post-tax but not implicit tax
      .filter(function (a) {
        return !["tax", "fee", "promo"].includes(a.name);
      })
      // sum up price PTFs and EBT redemption
      .reduce(function (total, a) {
        return total + a.price;
      }, 0) : 0) * refundCoef;
      var pretaxTotal = basePrice + pretaxAdjusters;
      // we take promo data from promosTotal as that has already correctly calculated rounding
      var overridePtf = i.priceTaxFeeAdjustments ? i.priceTaxFeeAdjustments.find(function (a) {
        return a.name === "priceoverride";
      }) : null;
      var discQty = overridePtf ? overridePtf.extra.qty : i.skuqty;
      var brclubPtf = i.priceTaxFeeAdjustments ? i.priceTaxFeeAdjustments.find(function (a) {
        return a.name === "promo" && a.extra.promo.extpromoid != null;
      }) : null;
      var brclubInfo = brclubPtf ? brclubPtf.extra.promo.pricing : null;
      if (brclubPtf) {
        i3.soldAt.extpromoid = brclubPtf.extra.promo.extpromoid;
      }
      if (i.priceTaxFeeAdjustments) {
        var discounts = {
          tax: 0,
          fee: 0
        };
        i.priceTaxFeeAdjustments.filter(function (a) {
          return !["tax", "fee"].includes(a.name);
        }).forEach(function (a) {
          discounts.tax += a.tax * refundCoef;
          discounts.fee += a.fee * refundCoef;
        });
        authorityAggregates = {};
        i.priceTaxFeeAdjustments.filter(function (a) {
          return ["tax", "fee"].includes(a.name);
        }).forEach(function (a) {
          var authorityRule = a.extra[a.name + "Rule"];
          var authorityName = authorityRule.name;
          var thisAuth = authorityAggregates[authorityName];
          var firstOfThisAuth = !thisAuth;
          if (firstOfThisAuth) {
            thisAuth = authorityAggregates[authorityName] = Object.assign({}, authorityRule);
            thisAuth.tax_amt = a.tax * refundCoef;
            thisAuth.fee_amt = a.fee * refundCoef;
            thisAuth.would_be_collected = (a.tax + a.fee) * refundCoef;
            thisAuth.implicit = !!a.priceFloat;
          } else {
            thisAuth.tax_amt += a.tax * refundCoef;
            thisAuth.fee_amt += a.fee * refundCoef;
            thisAuth.would_be_collected += (a.tax + a.fee) * refundCoef;
          }

          // we shall incrementally apply all tax and fee discounts to the to the tax authorities' tax amounts
          ["tax", "fee"].forEach(function (type) {
            if (discounts[type]) {
              var minFunc = i.refund ? Math.max : Math.min;
              var amountToApply = minFunc(thisAuth[type + "_amt"], -discounts[type]);
              thisAuth[type + "_amt"] -= amountToApply;
              discounts[type] += amountToApply;
            }
          });
        });

        // own code >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
        /*
        for (var authority in authorityAggregates) {
          var b = authorityAggregates[authority];
          var inclusivity = b.implicit ? "implicit" : "explicit";
          remaindersPerAuthority[inclusivity][authority] = remaindersPerAuthority[
            inclusivity
          ][authority] || { amount: 0, type: b.type };
          wouldbeRemaindersPerAuthority[inclusivity][authority] =
            wouldbeRemaindersPerAuthority[inclusivity][authority] || {
              amount: 0,
              type: b.type,
            };
           ["tax", "fee"].forEach((type) => {
            if (b[type + "_amt"]) {
              b[type + "_amt"] +=
                remaindersPerAuthority[inclusivity][authority].amount;
              var amount = round(b[type + "_amt"]);
              remaindersPerAuthority[inclusivity][authority].amount =
                b[type + "_amt"] - amount;
              b[type + "_amt"] = amount;
            }
          });
           // must be done independently as tax/fee could be 0 due to discount e.g. from ebt but would_be_collected is not affected by discounts as it is the theoretical amount if there was no discount
           if (b.would_be_collected) {
            b.would_be_collected +=
              wouldbeRemaindersPerAuthority[inclusivity][authority].amount || 0;
            var amount = round(b.would_be_collected);
            wouldbeRemaindersPerAuthority[inclusivity][authority].amount =
              b.would_be_collected - amount;
            b.would_be_collected = amount;
          }
        }
        */
        // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< own code

        i3.revauths = objectValues(authorityAggregates);

        // adjustment to taxable amount due to oveflow due to rounding accumulations
        var implicitAuthTotal = i3.revauths.reduce(function (t, v) {
          return t + (v.implicit ? v.would_be_collected || 0 : 0);
        }, 0);
        var actualTotal = basePrice + promosTotal + otherPtfs;
        var apparentTotal = pretaxTotal + implicitAuthTotal;
        var discrepancy = actualTotal - apparentTotal;
        pretaxTotal += discrepancy;
        i3.revauths.forEach(function (r) {
          return r.taxable_amt = round(pretaxTotal);
        });
      }
      i3.byweight = !!i.byweight;
      i3.pbqty = i.skuqty;
      i3.pbcents = i.skuprice;
      i3.tax_exempt = tax_exempt;
      i3.fee_exempt = fee_exempt;
      i3.ebtamount = -(ebtPriceAmount + ebtFeeAmount);

      // totalcents is strictly the taxable amount
      // the part about i3.ebtamount < 0 is just some nonsense to counter some other nonsense on the server side that happens when you have EBT refunds...
      i3.totalcents = pretaxTotal + (i3.ebtamount < 0 ? 0 : ebtPriceAmount);
      i3.xtra = {
        discount: {
          qty: totalDiscount ? discQty : undefined,
          cents: totalDiscount || undefined
        },
        pclub: {
          qty: brclubInfo ? brclubInfo.qty : undefined,
          cents: brclubInfo && brclubInfo.cents > 0 ? brclubInfo.cents : undefined
        },
        verified_age: i.verified_age,
        taxinc: i.taxinc,
        note: i.note
      };

      /**
       * Saving multi promos details to the xtra JSON field
       **/
      i3.xtra.promos = [];
      i3.xtra.ptdiscs = [];
      ptdiscs_3 = 0;
      multi_packs_3 = 0;
      isAltriaPromotion = false;
      isAltriaMultipack = false;
      if (i.priceTaxFeeAdjustments) {
        var promoTaxinc = undefined;
        i.priceTaxFeeAdjustments.forEach(function (ptf) {
          // we remove BR promos as they are already added separately above
          if (ptf.name === "promo" && !ptf.extra.promo.extpromoid && !ptf.extra.feeBuster) {
            // promo tax inclusivity / exclusivity flag overrides item tax inclusivity / exclusivity flag
            // in case of conflict among promos, inclusive wins (false gets overwritten, true doesn't)
            promoTaxinc = promoTaxinc || ptf.extra.promo.pricing.incltaxes;
            var promo = ptf;
            var promoAmount = -ptf.price,
              promoCents,
              promoQty = promo.extra.promo.pricing.qty;
            if (promo.extra.addFeebuster) {
              var feeBusterPromo = i.priceTaxFeeAdjustments.find(function (fbp) {
                return fbp.extra.feeBuster;
              });
              if (feeBusterPromo) {
                promoAmount -= feeBusterPromo.price;
              }
            }
            if (promo.extra.promo.type === "price") {
              // non-mbq-price promo needs to be "converted" to a cents-off type
              promoCents = promoAmount * promoQty / i.effectiveQuantity;
            } else {
              if (promo.extra.tier) {
                promoCents = promo.extra.tier.cents;
                promoQty = promo.extra.tier.qty;
              } else {
                promoCents = promo.extra.promo.pricing.cents;
              }
            }
            if (["mpr-discount", "mpo-discount"].includes(promo.extra.promo.type)) {
              multi_packs_3 += promoAmount;
            }
            if (!isAltriaPromotion) {
              isAltriaPromotion = promo.extra.promo.name.includes("Altria") && (promo.extra.promo.coupon_campaign == "Altri" || promo.extra.promo.coupon_campaign == "Loyal");
            }
            // own code >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
            if (isAltriaPromotion && !isAltriaMultipack) {
              // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< own code
              isAltriaMultipack = promo.extra.promo.name.toLowerCase().includes("multi");
            }
            if (promo.priority < 0 && promo.price) {
              i3.xtra.promos.push({
                qty: promoQty,
                cents: promoCents,
                total: promoAmount,
                type: promo.extra.promo.type,
                promoid: promo.extra.promo.id
              });
            }
            if (promo.priority > 0) {
              ptdiscs_3 -= promo.price;
              i3.xtra.ptdiscs.push({
                qty: promoQty,
                cents: promoCents,
                total: promoAmount,
                type: promo.extra.promo.type,
                campaign: promo.extra.promo.coupon_campaign,
                coupon_pid: promo.extra.promo.id
              });
            }

            // slim down the promo's upc list if it's big
            // only bother filtering if more upcs in promo than in basket
            if (promo.extra.promo.upcs.length > uniqueUpcs.length) {
              if (uniquePromoUpcCache[promo.extra.promo.id]) {
                promo.extra.promo.upcs = uniquePromoUpcCache[promo.extra.promo.id];
              } else {
                promo.extra.promo.upcs = promo.extra.promo.upcs.filter(function (a) {
                  return uniqueUpcs.includes(a);
                });
                uniquePromoUpcCache[promo.extra.promo.id] = promo.extra.promo.upcs;
              }
            }
          }
          if (ptf.name === "manualdiscount" && ptf.extra.source) {
            // we don't support the coffee club service yet

            /*
            if (ptf.extra.source.name === "coffeeclub") {
              let clubData =
                coffeeclubService.clubList &&
                coffeeclubService.clubList[ptf.extra.source.id];
              let name = clubData ? clubData.name : ptf.extra.source.id;
              i3.xtra.coffeeclub = {
                id: ~~ptf.extra.source.id,
                name: name,
                brnumber: ptf.extra.source.brnumber,
              };
            }
            */

            if (ptf.extra.source.name === "points") {
              i3.xtra.points = {
                id: ptf.extra.source.id
              };
            }
          }
        });
        if (promoTaxinc !== undefined) {
          i3.xtra.taxinc = promoTaxinc;
        }
      }

      /**
       * Fuel Details
       */
      /*
      if (i.moreinfo && i.moreinfo.fuelinfo) {
        i3.xtra.fuel_info = {
          pumpNo: i.moreinfo.fuelinfo.pumpNo,
          productName: i.moreinfo.fuelinfo.productName,
          volume: i.moreinfo.fuelinfo.volume,
          unitPrice: i.moreinfo.fuelinfo.unitPrice,
        };
      }
      */

      /**
       * MyBud Details
       */
      /*
      if (i.moreinfo && i.moreinfo.packageinfo) {
        i3.xtra.package_info = {
          label: i.moreinfo.packageinfo.label,
          extra: i.moreinfo.packageinfo.extra,
        };
      }
      */

      /**
       * Reporting for Altria
       */
      var pretaxTotalCash = pretaxTotal;
      var feebusterPtf = i.priceTaxFeeAdjustments ? i.priceTaxFeeAdjustments.find(function (a) {
        return a.name === "feebuster";
      }) : null;
      if (feebusterPtf && feebusterPtf.extra.cashPrice) {
        if (feebusterPtf.extra.config.enabled) {
          var _j = feebusterPtf.extra.cashPrice;
          var _basePrice = _j.intPrice;
          // we must deduct the sums, not from the PTFs of the cash-price item,
          // but rather from the PTFs of the CC item - because that is the money that was foregone -
          // in order to know the net income or "net sale" of the item.
          var _pretaxAdjusters = (i.priceTaxFeeAdjustments ? +i.priceTaxFeeAdjustments
          // exclude post-tax but not implicit tax
          .filter(function (a) {
            return a.priority <= 0 && a.name !== "feebuster" && !(a.extra && a.extra.feeBuster);
          })
          // sum up price PTFs and EBT redemption
          .reduce(function (total, a) {
            return total + a.price;
          }, 0) : 0) * refundCoef;
          pretaxTotalCash = _basePrice + round(_pretaxAdjusters);
        }

        // this contains a circular ref which would need fixing before serializing + is big data bloat
        delete feebusterPtf.extra.cashPrice;
      }
      ptdiscs_3 = round(ptdiscs_3);
      i3.xtra.reporting = {
        intPrice: i.intPrice,
        list_price_cents: i.intCcPrice,
        final_price_cents: round(pretaxTotal) - ptdiscs_3,
        final_price_cents_cash: round(pretaxTotalCash) - ptdiscs_3,
        // own code >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
        multipack: multi_packs_3 > 0 || isAltriaMultipack,
        // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< own code
        coupons_cents: ptdiscs_3
      };
      if (isAltriaPromotion) {
        i3.xtra.reporting.promotion = "altria";
        i3.xtra.reporting.multipack = isAltriaMultipack;
      }
      i3.xtra.ptfs = i.priceTaxFeeAdjustments;
      if (i.brportaldata) {
        i3.xtra.brportaldata = i.brportaldata;
      }
      if (feebusterExcludedDepts.includes(i.dept)) {
        i3.xtra.feebusterExcluded = true;
      }
      if (points_config !== null && points_config !== void 0 && points_config.enabled && isPointsExcludedDept(i.dept)) {
        i3.xtra.pointsExcluded = true;
      }

      // rounding for baskets coming in from sources that do not round their values
      for (var _i = 0, _arr = ["totalcents", "ebtamount"]; _i < _arr.length; _i++) {
        var field = _arr[_i];
        i3[field] = Math.round(i3[field]);
      }
      for (var _field in i3.soldAt) {
        if (typeof i3.soldAt[_field] === "number") {
          i3.soldAt[_field] = Math.round(i3.soldAt[_field]);
        }
      }
      var _iterator = _createForOfIteratorHelper(i3.revauths),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var revauth = _step.value;
          for (var _field2 in revauth) {
            if (typeof revauth[_field2] === "number") {
              revauth[_field2] = Math.round(revauth[_field2]);
            }
          }
        }
        // end of rounding

        // own code >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
        // find highest tax authority in which item - it will get the spare cent from all the rounding at the end if there is one

        /*
        i3.revauths.forEach((b) => {
          var inclusivity = b.implicit ? "implicit" : "explicit";
           if (
            highestItemAuth[inclusivity][b.type].uuid === null ||
            b.tax_amt > highestItemAuth[inclusivity][b.type].amount
          ) {
            highestItemAuth[inclusivity][b.type] = {
              uuid: i3.uuid,
              name: b.name,
              amount: b.tax_amt,
            };
          } else if (
            highestItemAuth[inclusivity][b.type].uuid === null ||
            b.fee_amt > highestItemAuth[inclusivity][b.type].amount
          ) {
            highestItemAuth[inclusivity][b.type] = {
              uuid: i3.uuid,
              name: b.name,
              amount: b.fee_amt,
            };
          } else if (
            highestItemAuth[inclusivity][b.type].uuid === null ||
            b.would_be_collected >
              highestItemAuth[inclusivity].wouldBe[b.type].amount
          ) {
            highestItemAuth[inclusivity].wouldBe[b.type] = {
              uuid: i3.uuid,
              name: b.name,
              amount: b.would_be_collected,
            };
          }
        });
        */
        // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< own code
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      itmp.push(i3);
    },
    promoPtfWithPartialInclusivityImpact,
    laterPromoExists,
    j,
    laterItem,
    authPtfs,
    processedAuthPtfs,
    twinAuthPtfs,
    secondTwinAuthPtfs,
    secondTwinAuthPtfsAuthoritynames,
    firstItemNewIntPrice,
    newItemEffectiveQty,
    newItem,
    i3,
    refundCoef,
    otherPtfs,
    authorityAggregates,
    ptdiscs_3,
    multi_packs_3,
    isAltriaPromotion,
    isAltriaMultipack;
  for (var itemIndex = 0, i; i = items[itemIndex]; ++itemIndex) {
    _loop();
  }

  // own code >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  /*
  var totalRemainders = {};
  var totalWouldbeRemainders = {};
  for (inclusivity of ["implicit", "explicit"]) {
    totalRemainders[inclusivity] = objectValues(
      remaindersPerAuthority[inclusivity],
    ).reduce(
      (t, v) => ({
        Tax: t.Tax + (v.type === "Tax" && v.amount),
        Fee: t.Fee + (v.type === "Fee" && v.amount),
      }),
      { Tax: 0, Fee: 0 },
    );
    totalWouldbeRemainders[inclusivity] = objectValues(
      wouldbeRemaindersPerAuthority[inclusivity],
    ).reduce(
      (t, v) => ({
        Tax: t.Tax + (v.type === "Tax" && v.amount),
        Fee: t.Fee + (v.type === "Fee" && v.amount),
      }),
      { Tax: 0, Fee: 0 },
    );
     if (
      totalWouldbeRemainders[inclusivity].Tax +
        totalWouldbeRemainders[inclusivity].Fee &&
      !(totalRemainders[inclusivity].Tax + totalRemainders[inclusivity].Fee)
    ) {
      console.warn(
        `We have totalWouldbeRemainders[${inclusivity}] of ${JSON.stringify(
          totalWouldbeRemainders,
        )} but no totalRemainders[${inclusivity}]`,
      );
    }
  }
   itmp.forEach((a) => {
    // add the tax remainders to the highest tax_amt of the basket and the fee remainders to the highest fee_amt of the basket
    for (inclusivity of ["implicit", "explicit"]) {
      if (
        a.uuid === highestItemAuth[inclusivity].Tax.uuid ||
        a.uuid === highestItemAuth[inclusivity].Fee.uuid ||
        a.uuid === highestItemAuth[inclusivity].wouldBe.Tax.uuid ||
        a.uuid === highestItemAuth[inclusivity].wouldBe.Fee.uuid
      ) {
        let found = a.revauths.find(
          (b) =>
            (b.name === highestItemAuth[inclusivity][b.type].name ||
              b.name === highestItemAuth[inclusivity].wouldBe[b.type].name) &&
            b.implicit === (inclusivity === "implicit"),
        );
         if (found) {
          let type_field = b.type.toLowerCase() + "_amt";
          found[type_field] = round(
            found[type_field] + totalRemainders[inclusivity][b.type],
          );
          totalRemainders[inclusivity][b.type] = 0;
          found.would_be_collected = round(
            found.would_be_collected +
              totalWouldbeRemainders[inclusivity][b.type],
          );
          totalWouldbeRemainders[inclusivity][b.type] = 0;
        } else {
          console.error(
            "highestItemAuth should have been findable for uuid " +
              a.uuid +
              " but wasn't",
          );
        }
      }
    }
     if (a.after) {
      var oldPosition = itmp.indexOf(a);
      var itemAfter = itmp.find((b) => b.uuid === a.after);
      var newPosition = itmp.indexOf(itemAfter) + 1;
      itmp.splice(newPosition, 0, itmp.splice(oldPosition, 1)[0]);
    }
  });
  */

  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< own code

  itmp.forEach(function (a) {
    if (a.after) {
      var oldPosition = itmp.indexOf(a);
      var itemAfter = itmp.find(function (b) {
        return b.uuid === a.after;
      });
      var newPosition = itmp.indexOf(itemAfter) + 1;
      itmp.splice(newPosition, 0, itmp.splice(oldPosition, 1)[0]);
    }
  });
  return itmp;
};
module.exports = convertPurchaseListToBackendFormat;